import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import css from "./Table.module.css";

const Root = React.forwardRef(
  ({ dense = false, className, children, ...rest }, ref) => (
    <div className={clsx(css.wrapper, className)}>
      <table
        ref={ref}
        className={css.table}
        {...(dense ? { "data-dense": "" } : {})}
        {...rest}
      >
        {children}
      </table>
    </div>
  ),
);

Root.displayName = "Table.Root";

Root.propTypes = {
  dense: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const Header = React.forwardRef(({ className, children, ...rest }, ref) => (
  <thead ref={ref} className={clsx(css.header, className)} {...rest}>
    {children}
  </thead>
));

Header.displayName = "Table.Header";

Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Body = React.forwardRef(({ className, children, ...rest }, ref) => (
  <tbody ref={ref} className={clsx(css.body, className)} {...rest}>
    {children}
  </tbody>
));

Body.displayName = "Table.Body";

Body.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Row = React.forwardRef(
  ({ clickable = false, className, children, ...rest }, ref) => (
    <tr
      ref={ref}
      className={clsx(clickable && css.clickable, className)}
      {...(clickable ? { tabIndex: 0 } : {})}
      {...rest}
    >
      {children}
    </tr>
  ),
);

Row.displayName = "Table.Row";

Row.propTypes = {
  clickable: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const HeaderCell = React.forwardRef(
  ({ align = "start", className, children, ...rest }, ref) => (
    <th
      ref={ref}
      className={clsx(css.headerCell, className)}
      {...(align !== "start" ? { "data-align": align } : {})}
      {...rest}
    >
      {children}
    </th>
  ),
);

HeaderCell.displayName = "Table.HeaderCell";

HeaderCell.propTypes = {
  align: PropTypes.oneOf(["start", "end"]),
  className: PropTypes.string,
  children: PropTypes.node,
};

const Cell = React.forwardRef(
  ({ align = "start", className, children, ...rest }, ref) => (
    <td
      ref={ref}
      className={clsx(css.cell, className)}
      {...(align !== "start" ? { "data-align": align } : {})}
      {...rest}
    >
      {children}
    </td>
  ),
);

Cell.displayName = "Table.Cell";

Cell.propTypes = {
  align: PropTypes.oneOf(["start", "end"]),
  className: PropTypes.string,
  children: PropTypes.node,
};

const Table = { Root, Header, Body, Row, HeaderCell, Cell };

export default Table;
